<template>
    <section class="experience">
        <h3 class="mb-8">Expérience(s) :</h3>

        <div class="flex items-center gap-3 mb-8">
            <vs-button
                v-if="canUpdate()"
                id="addTraining"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-plus"
                @click="createResource()"
            >
                Ajouter une expérience
            </vs-button>
            <vs-button
                v-if="isEvaluable.length && canUpdate() && planAllow('eval-tiers-croise')"
                id="inviteTiers"
                color="primary"
                type="border"
                @click="inviteTiers"
            >
                Inviter un tiers à évaluer
            </vs-button>

            <div v-else-if="!planAllow('eval-tiers-croise') && !shouldHideOptions()" style="position: relative; float: left" title="Votre formule n'inclut pas cette fonctionnalité">
                <vs-button
                    id="inviteTiers"
                    color="primary"
                    type="border"
                    disabled="true"
                >
                    Inviter un tiers à évaluer
                </vs-button>
                <vs-icon class="button-bullet" bg="#FF9B3A" round >
                    <CrownIcon style="width: 16px; height: 16px; padding: 3px"/>
                </vs-icon>
            </div>

            <feather-icon 
                icon="SettingsIcon" 
                class="option cursor-pointer opaver"
                @click="showOptions = true"
            />
        </div>

        <DialogPrompt
            :active.sync="showOptions"
            title="Ordonner les expériences en cours"
            cancel-text="Annuler"
            accept-text="Enregistrer"
            @cancel="showOptions = false"
            @close="showOptions = false"
            @accept="closeDialogOrderHandle()"
        >
            <Draggable 
                :data="currentOrderedItems"
                :table="{
                    columns: [
                        { label: 'Ordre', name: 'order' },
                        { label: 'Nom', name: 'title' }
                    ]
                }"
                @updated="updatedOrder = $event"
            />

        </DialogPrompt>

        <DialogPrompt
            :active.sync="showPopup"
            :title="getDataPrompt.title"
            cancel-text="Annuler"
            accept-text="Enregistrer"
            :button-accept="getDataPrompt.btnAccept"
            :is-valid="!hasError"
            @cancel="resetResource"
            @close="resetResource"
            @accept="storeResource"
        >
            <div class="con-exemple-prompt">
                
                <vs-row class="mt-5 mb-8">
                    <vs-col>
                        <vs-radio 
                            v-model="experienceCategorie" 
                            vs-value="0"
                            :disabled="this.formType != 'create'"
                            @click="resetResource()"
                        >
                            Grille
                        </vs-radio>
                        <vs-radio 
                            v-model="experienceCategorie" 
                            vs-value="1"
                            class="ml-5"
                            :disabled="this.formType != 'create'"
                            @click="resetResource()"
                        >
                            Poste / stage Myskilliz
                        </vs-radio>
                        <vs-radio 
                            v-model="experienceCategorie" 
                            vs-value="2" 
                            class="ml-5"
                            :disabled="this.formType != 'create'"
                            @click="resetResource()"
                        >
                            Autre expérience
                        </vs-radio>
                    </vs-col>
                </vs-row>

                <!-- Grille -->
                <div v-if="experienceCategorie == experienceCategories.GRID">
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full">
                            <h5>Ajouter une grille sur le parcours</h5>
                        </div>
                    </div>

                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>Type* :</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <Multiselect
                                v-model="resource.experience_type"
                                name="experienceTypes"
                                :options="experienceTypes"
                                :multiple="false"
                                :group-select="false"
                                placeholder="Recherche ..."
                                track-by="id"
                                label="name"
                                select-label
                                selected-label
                                deselect-label
                                :loading="experienceTypesLoading"
                            >
                                <span slot="noResult">Aucun résultat.</span>
                            </Multiselect>
                        </div>
                    </div>

                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>Expérience* :</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <Multiselect
                                v-model="resource.grid"
                                name="experienceTypes"
                                :options="grids.data"
                                :multiple="false"
                                :group-select="false"
                                placeholder="Recherche ..."
                                group-label="group"
                                group-values="items"
                                track-by="id"
                                label="title"
                                select-label
                                selected-label
                                deselect-label
                                :loading="grids.loading"
                            >
                                <span slot="noResult">Aucun résultat.</span>
                            </Multiselect>
                        </div>
                    </div>

                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>Service :</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <Multiselect
                                v-model="resource.service"
                                name="experienceTypes"
                                :options="groupedServicesByEstablishments"
                                :multiple="false"
                                :group-select="false"
                                placeholder="Recherche ..."
                                group-values="services"
                                group-label="establishment"
                                track-by="id"
                                label="title"
                                select-label
                                selected-label
                                deselect-label
                                :loading="establishments.loading"
                            >
                                <span slot="noResult">Aucun résultat.</span>
                            </Multiselect>
                        </div>
                    </div>
                </div>

                <!-- Poste / stage Myskilliz -->
                <div
                    v-if="experienceCategorie == experienceCategories.JOB"
                    class="vx-row mb-6"
                >
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Poste ou stage déjà existant :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <Multiselect
                            v-if="formType == 'create' && jobs.length > 0"
                            v-model="resource.job"
                            :multiple="false"
                            label="title"
                            :options="orderedJobs"
                            group-label="establishmentService"
                            group-values="jobs"
                            :group-select="false"
                            name="jobTitle"
                            placeholder="Recherche ..."
                            track-by="id"
                            select-label
                            select-group-label
                            selected-label
                            deselect-label
                            deselect-group-label
                        >
                            <span slot="noResult">Aucun résultat.</span>
                        </Multiselect>
                        <div v-else>{{ resource.job ? resource.job.title : 'N/A' }}</div>
                    </div>
                </div>
                
                <!-- Autre expérience -->
                <div v-if="experienceCategorie == experienceCategories.OTHER">
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>Type* :</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <Multiselect
                                v-model="resource.experience_type"
                                name="experienceTypes"
                                :options="experienceTypes"
                                :multiple="false"
                                :group-select="false"
                                placeholder="Recherche ..."
                                track-by="id"
                                label="name"
                                select-label
                                selected-label
                                deselect-label
                                :loading="experienceTypesLoading"
                                :disabled="this.formType != 'create'"
                            >
                                <span slot="noResult">Aucun résultat.</span>
                            </Multiselect>
                        </div>
                    </div>
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>Libellé de l’expérience *:</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input
                                v-model="resource.title"
                                name="title"
                                class="w-full"
                            />
                        </div>
                    </div>

                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>Établissement *:</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-row v-if="choiceEstablishmentInList">
                                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10" class="p-0">
                                    <Multiselect
                                        v-model="resource.establishment"
                                        name="establishment"
                                        :options="establishments.data"
                                        :multiple="false"
                                        :group-select="false"
                                        placeholder="Recherche ..."
                                        track-by="id"
                                        label="name"
                                        select-label
                                        selected-label
                                        deselect-label
                                        :loading="establishments.loading"
                                    >
                                        <span slot="noResult">Aucun résultat.</span>
                                    </Multiselect>
                                </vs-col>
                                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" class="p-0">
                                    <vs-button icon="edit-3" size="large" color="dark" type="line" title="Saisir une autre valeur..." class="btn-block" @click="choiceEstablishmentInList = false"></vs-button>
                                </vs-col>
                            </vs-row>

                            <vs-row v-else>
                                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10" class="p-0">
                                    <vs-input
                                        v-model="resource.establishment_name"
                                        name="establishment"
                                        class="w-full"
                                        placeholder="Nom de l'établissement..."
                                    />
                                </vs-col>
                                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" class="p-0">
                                    <vs-button icon="list" color="dark" type="line" title="Choisir dans la liste..." class="btn-block" @click="choiceEstablishmentInList = true"></vs-button>
                                </vs-col>
                            </vs-row>


                        </div>
                    </div>

                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>Service :</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input
                                v-model="resource.service_title"
                                name="service"
                                class="w-full"
                            />
                        </div>
                    </div>
                    
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Dates :</span>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                        <vs-input
                            label="Début*"
                            type="date"
                            v-model="resource.start_date"
                            name="start_date"
                            class="w-full"
                        />
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                        <vs-input
                            label="Fin"
                            type="date"
                            v-model="resource.end_date"
                            name="end_date"
                            class="w-full"
                        />
                    </div>
                </div>
                <!-- <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Date de fin </span><span v-if="!resource.job">*</span><span>:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input
                            type="date"
                            v-model="resource.end_date"
                            name="end_date"
                            class="w-full"
                            description-text="Une expérience est évaluable (y compris par un tiers) et auto-évaluable jusqu'à sa date de fin"
                        />
                    </div>
                </div> -->

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Type d'accueil :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-select
                            type="date"
                            v-model="resource.reception_type"
                            name="reception_type"
                            class="w-full"
                        >
                            <vs-select-item :key="i" :value="item" :text="item" v-for="(item, i) in receptionTypes" />
                        </vs-select>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span style="float: left;line-height: 26px;">
                            Pièce jointe &nbsp;
                        </span>
                        <vs-chip v-if="!documentLicence" color="secondary">
                            <b>Gratuit jusqu'à {{ postMaxSizePerPerson }} Mo</b>
                        </vs-chip>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <template v-if="resource.doc_path">
                            <template v-for="(doc_path, index) in resource.doc_path.split(';')">
                                <div class="vx-row mb-3">
                                    <div
                                        class="inline mr-1 float-left cursor-pointer"
                                    >
                                        <a @click.prevent="download(doc_path)">{{ doc_path.split('/').pop() }}</a>
                                    </div>
                                    <vs-button
                                        :id="'deleteDoc_' + doc_path"
                                        color="primary"
                                        type="border"
                                        size="small"
                                        icon-pack="feather"
                                        icon="icon-trash"
                                        @click="removeDocPath(resource, doc_path)"
                                        style="display: inline; margin-top: -0.5rem;"
                                    />
                                </div>
                            </template>
                        </template>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input
                                type="file"
                                multiple
                                :accept="acceptExtensions('all')"
                                name="doc_path"
                                class="w-full"
                                @change="selectFile"
                                :danger="this.fileError.message"
                                :danger-text="this.fileError.message"
                            />
                        </div>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Visible dans l'export :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full mb-2">
                        <vs-checkbox
                            class="w-full"
                            v-model="resource.is_exportable"
                            name="isExportable"
                        ></vs-checkbox>
                    </div>
                </div>
            </div>
        </DialogPrompt>

        <DialogPrompt
            :active.sync="showPopupFullStorage"
            title="Votre espace de stockage est plein"
            cancel-text="Annuler"
            accept-text="OK"
            @close="showPopupFullStorage = false"
            @accept="showPopupFullStorage = false"
        >
            <div class="con-exemple-prompt">
                <p>{{ popupFullStorageMessage }}</p>
            </div>
        </DialogPrompt>

        <vs-table
            :sst="true"
            @sort="eventSortByCol"
            :data="orderedItems"
            no-data-text="Aucune donnée à afficher"
            style="width:100%;"
        >
            <template slot="thead">
                <vs-th>
                    <Sort name="type" @sort="eventSortByCol">Type</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="title" @sort="eventSortByCol">Libellé</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="start_date" @sort="eventSortByCol">Date de début</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="end_date" :value="apiParams.sortBy['end_date']" @sort="eventSortByCol">Date de fin</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="service_title" @sort="eventSortByCol">Service</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="establishment_name" @sort="eventSortByCol">Établissement</Sort>
                </vs-th>
                <vs-th>
                    Document
                </vs-th>
                <vs-th>
                    <Sort name="is_exportable" @sort="eventSortByCol">Export</Sort>
                </vs-th>
                <vs-th v-if="canUpdate()">
                    Actions
                </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr
                    v-for="(item, indextr) in data"
                    :key="indextr"
                    :data="item"
                >
                    <vs-td :data="item.title">
                        {{ item.experience_type_name }}
                    </vs-td>
                    <vs-td :data="item.title">
                        {{ item.title }}
                    </vs-td>
                    <vs-td :data="item.start_date">
                        {{ item.start_date || "-" | date }}
                    </vs-td>
                    <vs-td :data="item.end_date">
                        {{ item.end_date || "-" | date }}
                    </vs-td>
                    <vs-td :data="item.service_title">
                        {{ item.service_title }}
                    </vs-td>
                    <vs-td :data="item.establishment ? item.establishment.name : item.establishment_name">
                        {{ item.establishment ? item.establishment.name : item.establishment_name }}
                    </vs-td>

                    <vs-td v-if="item.doc_path">
                        <template v-for="(doc_path, index) in item.doc_path.split(';')">
                            <i
                                v-if="doc_path"
                                :key="'file_'+doc_path+index"
                                :class="'ml-1 fa fa-file'+(doc_path.split('.').pop() === 'pdf' ? '-pdf' : '')"
                                style="font-size: 2rem; color: rgba(var(--vs-primary),1)"
                                @click="download(doc_path)"
                                v-tooltip="{
                                    content: doc_path.split('/').pop(),
                                    placement: 'top-start',
                                    classes: ['occ-description']
                                }"
                            ></i>
                        </template>
                    </vs-td>
                    <vs-td v-else></vs-td>
                    <vs-td>
                        <feather-icon
                            v-if="item.is_exportable"
                            icon="CheckSquareIcon"
                            svg-classes="h-6 w-6 icon-info vs-icon-primary"
                            class="ml-2"
                            v-tooltip="'Export autorisé'"
                            @click="exportableClickHandle(item, false)"
                        />
                        <feather-icon
                            v-else
                            icon="SquareIcon"
                            svg-classes="h-6 w-6 icon-info"
                            class="ml-2"
                            @click="exportableClickHandle(item, true)"
                        />
                    </vs-td>

                    <vs-td v-if="canUpdate()">
                        <vs-button
                            :id="'modifyJob_' + indextr"
                            v-tooltip="'Modifier'"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-edit"
                            @click="updateResource(item)"
                        />
                        <vs-button
                            :id="'deleteJob_' + indextr"
                            v-tooltip="'Supprimer'"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-trash"
                            style="margin-left: 1rem;"
                            @click="deleteResource(item)"
                        />
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </section>
</template>

<script>
import Multiselect from "vue-multiselect";
//import Datepicker from "vuejs-datepicker";
import { fr } from "vuejs-datepicker/dist/locale";
import { format } from 'date-fns';
import CrownIcon from '@components/svg/CrownIcon';
export default {
    name: "EmployeeJobsStages",
    components: {
        Multiselect,
        //Datepicker
        CrownIcon
    },
    props: {
        api: {
            type: String
        },
        employee: {
            required: false,
            type: Object
        },
        receptionTypes: {
            type: Array,
            required: true
        },
        documentLicence: {
            required: false,
            type: Boolean
        }
    },
    data() {
        return {
            fr: fr,
            log: console.log,
            resource: {
                job: {},
                service: null
            },
            showPopup: false,
            showOptions: false,
            showPopupFullStorage: false,
            popupFullStorageMessage: null,
            loading: true,
            formError: true,
            formType: "create",
            jobs: [],
            jobsLoading: true,
            experienceTypes: [],
            experienceTypesLoading: true,
            establishments: {
                data: [],
                loading: true
            },
            grids: {
                data: [],
                loading: false
            },
            prompt: {
                show: {
                    title: "Consulter une expérience",
                    btnAccept: "false"
                },
                create: {
                    title: "Ajouter une expérience",
                    btnAccept: "filled"
                },
                update: {
                    title: "Modifier une expérience",
                    btnAccept: "filled"
                }
            },
            choiceEstablishmentInList: true,
            files: null,
            fileError: {
                message: null,
            },
            postMaxSizePerPerson: process.env.MIX_TOTAL_SPACE_WITHOUT_LICENCE,
            maxFileSize: process.env.MIX_PHP_MAX_FILESIZE,
            experienceCategories: {
                GRID: 0,
                JOB: 1,
                OTHER: 2
            },
            experienceCategorie: null,
            updatedOrder: []
        };
    },
    watch: {
        'resource.establishment': function(value) {
            this.resource.establishment_name = null;
        },

        'resource.establishment_name': function(value) {
            this.resource.establishment = null;
        },
    },
    computed: {
        hasError() {
            let error = true;

            if (this.resource.job) {
                error = !this.resource.start_date;
            } else if (this.resource.grid) {
                error =
                    !this.resource.experience_type ||
                    !this.resource.grid ||
                    !this.resource.start_date;
            } else {
                error =
                    !this.resource.title ||
                    //!this.resource.service_title ||
                    //(!this.resource.establishment_name && !this.resource.establishment) ||
                    !this.resource.start_date
                    //|| !this.resource.end_date;
            }

            return error;
        },
        orderedJobs() {
            let nonUniqueEstablishmentsFromServices = this.jobs.map(j => j.service.establishment)
            let uniqueEstablishments = []
            nonUniqueEstablishmentsFromServices.forEach(e => {
                if (!uniqueEstablishments.map(ets => ets.id).includes(e.id)) {
                    uniqueEstablishments.push(e)
                }
            })

            let jobsSorted = []

            uniqueEstablishments.forEach(e => {
                e.services.forEach((s) => {

                    const jobs = this.jobs ? this.jobs
                            .filter((j) => j.service.id == s.id)
                            .sort(function(a, b) {
                                if (a.title > b.title) return 1
                                if (a.title < b.title) return -1
                                return 0
                            })
                        : []

                    jobsSorted.push({
                        establishmentService: `${e.name} - ${s.title}`,
                        jobs: jobs,
                    })
                })
            })

            return jobsSorted.sort(function(a, b) {
                if (a.establishment > b.establishment) return 1
                if (a.establishment < b.establishment) return -1
                return 0
            })
        },
        isEvaluable() {
            // Seuls les expériences en cours sont proposées dans la form d'invitation
            let current = [];
            if (!this.loading) {
                this.items.forEach(experience => {
                    if (experience.end_date == null || (new Date(experience.end_date)).getTime() > Date.now()) {
                        current.push(experience)
                    }
                });
            }
            return current;
        },

        groupedServicesByEstablishments() {
            let items = [];

            this.establishments.data.forEach(e => {
                items.push({
                    establishment: e.name,
                    services: e.services.sort((a, b) => a.title > b.title ? 1 : -1)
                });
            });

            return items;
        },

        orderedItems() {
            if (!this.items.length) return []

            return this.items.map(item => {
                item.order = item.order == 0 ? 9999 : item.order;
                return item;
            }).sort((a, b) => a.order > b.order ? 1 : -1)
        },
        currentOrderedItems() {
            return _.cloneDeep(this.orderedItems).filter(i => !i.end_date).map((item, i) => {
                item.order = i + 1
                return item
            })
        }

    },
    methods: {
        selectFile(e) {
            this.files = null
            this.fileError.message = null
            if (e.target.files.length !== 0) {
                Array.from(e.target.files).forEach(file => {
                    if (file.size >= this.maxFileSize*1024*1024) {
                        this.fileError.message = 'La taille du fichier de '+this.getReadableFileSizeString(file.size)+' est supérieure à la valeur autorisée de '+this.maxFileSize+' Mo'
                    }
                    else {
                        this.file = file
                        if (!this.files) this.files = []
                        this.files.push(file)
                    }
                })
            }
        },
        removeDocPath(resource, doc_path) {
            this.$swal({
                title: `Attention`,
                html: `Êtes-vous sûr de vouloir supprimer cet élément ?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Je confirme',
                cancelButtonText: 'Non'
            }).then(response => {
                if (response.value) {
                    let jobClass = 'EmployeeJob'
                    if (resource.experience_type && resource.experience_type.category == 1) jobClass = 'Experience'
                    else if (resource.experience_type && resource.experience_type.category == -1) jobClass = 'OldJob'
                    window
                        .axios({
                            method: "post",
                            url: "/api/gestion/employees/career/doc/delete",
                            params: { path: doc_path, class: jobClass, id: resource.pivot_id || resource.id },
                        })
                        .then(response => {
                            this.loadItems().then(() => {
                                this.$emit('change')
                                this.setResource(this.items.find(i => i.id === resource.id))
                            })
                        })
                        .catch(err => {
                            this.notifyError(err, `Une erreur est survenue`, true);
                        });
                }
            })
        },
        download(path) {
            window
                .axios({
                    method: "get",
                    url: "/api/gestion/employees/career/doc",
                    params: { path: path },
                    responseType: 'blob', // Indique que la réponse sera un fichier
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', path.split('/').pop()); // Spécifie le nom du fichier à télécharger
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(async (err) => {
                    let errorResponse = await err.response.data.text();
                    const errorObj = JSON.parse(errorResponse);
                    err.response.status = err.code
                    err.message = errorObj.message
                    this.notifyError(err, `Une erreur est survenue`, true);
                });
        },

        async loadJobs() {
            window
                .axios({
                    method: "get",
                    url: "/api/referentiel/jobs",
                    params: { perpage: 999, include: ['service.establishment.services'], sortBy: {"title": 'asc'}}
                })
                .then(response => {
                    let jobs = response.data.data;
                    jobs.forEach(j => {
                        if (j.type === 'poste') j.title = 'Poste - ' + j.title
                        else j.title = 'Stage - ' + j.title
                    })
                    this.jobs = jobs
                    this.jobsLoading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        async loadExperienceTypes() {
            window
                .axios({
                    method: "get",
                    url: "/api/gestion/employees/experience-types",
                    params: {
                        perpage: 100,
                        filter: "category|>|0;category|!=|2;category|<=|3",
                        sortBy: {'category': 'desc', 'name': 'asc'},
                    }
                })
                .then(response => {
                    this.experienceTypes = response.data.data;
                    this.experienceTypesLoading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        async loadEstablishments() {
            return window
                .axios({
                    method: "get",
                    url: "/api/referentiel/establishments",
                    params: {
                        perpage: 9999,
                        include: ['services']
                    }
                })
                .then(response => {
                    this.establishments.data = response.data.data;
                    this.establishments.loading = false;
                })
                .catch(err => {
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        async loadGrids() {
            
            this.grids.loading = true;

            return window
                .axios({
                    method: "get",
                    url: "/api/referentiel/grids",
                    params: {
                        perpage: 999,
                        include: ['sector'],
                    }
                })
                .then(response => {
                    this.groupForMultiselect()
                    this.grids.data = this.groupForMultiselect(response.data.data, ['sector.title']);
                    this.grids.loading = false;
                })
                .catch(err => {
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        canUpdate() {
            return this.canMulti("update", "employees", this.employee.services.map(s => s.id));
        },

        createResource() {
            this.resourceReadonly = false;
            this.resetResource();
            this.formType = "create";
            this.showPopup = true;
        },

        updateResource(resource) {
            
            if (resource.grid) {
                this.experienceCategorie = this.experienceCategories.GRID;
            } else if (resource.job) {
                this.experienceCategorie = this.experienceCategories.JOB;
            } else {
                this.experienceCategorie = this.experienceCategories.OTHER;
            }

            this.resourceReadonly = false;
            this.resetResource();
            this.setResource(resource);
            this.formType = "update";
            this.showPopup = true;
        },

        exportableClickHandle(resource, exportable) {
            resource.is_exportable = exportable;
            this.setResource(resource);
            this.formType = "update";
            this.storeResource();
        },

        storeResource() {
            let data = JSON.parse(JSON.stringify(this.resource));

            data.end_date = data.end_date ? this.getDate(data.end_date) : data.end_date;
            data.files = this.files
            data.is_exportable = data.is_exportable ? 1 : 0;

            if (this.experienceCategorie == this.experienceCategories.GRID) {
                data.type = 'grid';
                data.grid_id = data.grid?.id;
                data.experience_type_id = data.experience_type?.id;
                data.service_id = data.service?.id;
                delete data.grid;
                delete data.experience_type;
                delete data.service;
            } else if (this.experienceCategorie == this.experienceCategories.JOB) {
                data.type = 'job'
                data.job_id = data.job?.id;
                delete data.job;
            } else {
                data.type = 'other';
                data.service_id = data.service?.id;
                data.experience_type_id = data.experience_type?.id;
                data.establishment_id = data.establishment?.id;
                delete data.service;
                delete data.experience_type;
                delete data.establishment;
            }

            this.localLoading()
            if (data.id) {
                this.apiUpdate(
                    data,
                    this.resource.id,
                    resp => {
                        if (!resp.data.availableSizeValidation) {
                            this.showPopupFullStorage = true
                            this.popupFullStorageMessage = resp.data.availableSizeValidationMessages
                        }
                        this.loadItems()
                        this.$emit('change')
                        this.endLocalLoading()
                        this.files = null
                    },
                    (err) => {
                        this.files = null
                        this.showPopup = true
                        this.endLocalLoading()
                    },
                    {'Content-Type': 'multipart/form-data'}
                );
            } else {
                this.apiCreate(
                    data,
                    resp => {
                        if (!resp.data.availableSizeValidation) {
                            this.showPopupFullStorage = true
                            this.popupFullStorageMessage = resp.data.availableSizeValidationMessages
                        }
                        this.loadItems()
                        this.$emit('change')
                        this.endLocalLoading()
                        this.files = null
                    },
                    (err) => {
                        this.files = null
                        this.showPopup = true
                        this.endLocalLoading()
                    },
                    {'Content-Type': 'multipart/form-data'}
                );
            }
        },

        deleteResource(resource) {
            if (!!resource.grid || !!resource.job) {
                let type = resource.job ? 'job' : 'grid'
                this.apiSpecificDelete(resource.id, '/api/gestion/employees/' + this.employee.id + '/jobs', type, () => {
                    this.loadItems()
                    this.$emit('change')
                })
            } else {
                this.apiSpecificDelete(resource.id, '/api/gestion/employees/' + this.employee.id + '/experiences', null, () => {
                    this.loadItems()
                    this.$emit('change')
                })
            }
        },

        setResource(data) {
            let dataTemp = JSON.parse(JSON.stringify(data));
            dataTemp.start_date = this.getDate(dataTemp.start_date);
            dataTemp.end_date = dataTemp.end_date ? this.getDate(dataTemp.end_date) : dataTemp.end_date;
            dataTemp.reception_type = dataTemp.reception_type || 'ESAT / IME';
            this.resource = {...dataTemp};
            this.choiceEstablishmentInList = !this.resource.establishment_name ? true : false;
        },

        resetResource() {
            this.resource = {
                job: null,
                start_date: format(new Date(), "yyyy-MM-dd"),
                end_date: null,
                title: null,
                service_title: null,
                establishment_name: null,
                establishment: null,
                doc_path: null,
                reception_type: 'ESAT / IME',
                is_exportable: true,
                grid: null,
                experience_type: null,
                service: null,
            };
            this.files = null
        },

        apiSpecificDelete(id, specificApi, type, callback) {
            this.$swal({
                title: `Êtes-vous sûr de vouloir supprimer cet élément ?`,
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ok',
                cancelButtonText: 'Annuler'
            }).then(async result => {
                if (result.value) {
                    window.axios({
                        method: 'delete',
                        url: `${specificApi}/${id}`,
                        params: {type: type}
                    })
                        .then(response => {

                            if (response.status === 204) {
                                this.notifySuccess('Élement supprimé avec succès !')
                            } else {
                                this.notifyError('Erreur', `Une erreur est survenue lors de la suppression`)
                            }

                            if (callback) {
                                callback(response);
                            }
                        })
                        .catch((err) => {
                            this.notifyError(err, `Une erreur est survenue`)
                        })
                }
            })
        },
        inviteTiers() {
            this.$emit('invite-tiers');
        },

        closeDialogOrderHandle() {
            this.showOptions = false;
            const items = this.updatedOrder.length > 0 ? this.updatedOrder : this.currentOrderedItems

            this.updatedOrderHandle(items)
        },

        updatedOrderHandle(items) {
            let toUpdate = [];
            items.forEach((item, i) => {
                this.setResource(item)
                toUpdate.push(this.storeResource());
            });

            this.resetResource();

            Promise.all(toUpdate).then(() => {
                this.notifySuccess('Succès', 'Ordre modifié avec succès !')
                this.orderChanged = false;
                this.dragging = null;
            })
        }
    },
    created() {
        this.apiParams = {
            sortBy: {"end_date": "desc"}
        };
        this.resetResource();
        this.loadItems();
        this.loadGrids();
        this.loadJobs();
        this.loadExperienceTypes();
        this.loadEstablishments();

        this.experienceCategorie = this.experienceCategories.JOB;
    }
};
</script>

<style lang="scss" scoped>
.btn-block {
    width: 100% !important;
}
::v-deep .con-text-validation {
    font-size: 0.8rem;
}
</style>
